interface HeroWaveProps {
  color?: string
}

const HeroWave = ({ color }: HeroWaveProps) => {
  const fillColor = color || 'url(#heroGradient)'

  return (
    <div className="absolute inset-x-0 bottom-0 z-10 h-52">
      <svg className="h-52 w-full" viewBox="0 0 1440 200" preserveAspectRatio="none" aria-hidden>
        {!color && (
          <defs>
            <linearGradient id="heroGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#62cadd" />
              <stop offset="100%" stopColor="#2e76bc" />
            </linearGradient>
          </defs>
        )}

        <path d="M0 0 L420 140 L1440 0 L1440 200 L0 200 Z" fill={color || fillColor} />
      </svg>
    </div>
  )
}

export default HeroWave
